// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2OP0R","label":"Section_label__3_SYD","contentWrap":"Section_contentWrap__3eY7C","footer":"Section_footer__15Q5J","footerInner":"Section_footerInner__1vMrn"};